export default {
  methods: {
    publicPath(src) {
      return `${window.publicPath}${src}`
    },
  },
}
